<template>
  <div>
    <!-- 导航条 -->
    <via-nav-bar
      title="个人中心"
      :border="false"
      @click-left="$router.$back()"
    >
      <div
        slot="right"
        class="nav-icon-box"
        @click="showMenu = true"
      >
        <van-icon
          class="nav-bar-lright-icon"
          class-prefix="icon"
          name="navicon"
          :size="$vw('25px')"
        />
      </div>
    </via-nav-bar>

    <!-- 主体 -->
    <van-skeleton
      :row="15"
      title
      :loading="pageLoading"
      :style="{marginTop: $vw(15)}"
    >
      <div class="top-bg">
        <div
          class="avatar"
          :style="{ backgroundImage: `url(${ $imgHook(userInfo.avatar || 'https://picsum.photos/300/300')})` }"
        />
        <div class="nickname">{{ userInfo.nickname }}</div>
        <div class="tags">
          <div class="tag user-type">{{ typeDetail }}</div>
          <div class="tag join-time">{{ joinTime }}</div>
        </div>
        <div class="introduction">{{ userInfo.introduction }}</div>
      </div>

      <!-- 插件列表 -->
      <div class="plugin-list">
        <via-plugin-row-card
          v-for="item in plugins"
          :key="item.id"
          class="plugin-list-card"
          :plugin-id="item.id"
          :icon="item.icon"
          :icon-color="item.iconColor"
          :icon-bg-color="item.iconBgColor"
          :name="item.name"
          :update-time="Number(item.updateTime)"
          :author="`简介: ${item.introduction}`"
        />
      </div>
    </van-skeleton>

    <!-- menu -->
    <van-action-sheet
      v-model="showMenu"
      :actions="menu"
      cancel-text="取消"
      @select="menuSelectHandle"
      @cancel="showMenu = false"
    />
  </div>
</template>

<script>
import ViaPluginRowCard from 'components/common/via-plugin-row-card'
import { ActionSheet, Skeleton } from 'vant'
import { UserType, Review } from '~/utils/enum'

export default {
  name: 'User',
  components: {
    [ViaPluginRowCard.name]: ViaPluginRowCard,
    [ActionSheet.name]: ActionSheet,
    [Skeleton.name]: Skeleton
  },
  data() {
    return {
      userInfo: {},
      showMenu: false,
      pageLoading: true,
      timerId: null
    }
  },
  computed: {
    // 菜单选项
    menu() {
      const userId = this.$store.getters['globalData/userInfo'].id
      const myMenu = [
        { name: '修改资料', color: 'var(--light40)', code: 'updateMe' },
        { name: '修改密码', color: 'var(--light40)', code: 'updatePassword' }
      ]
      const othersMenu = [
        { name: '联系作者', color: 'var(--light40)', code: 'concatAuthor' }
      ]
      if (Number(userId) === Number(this.$route.params.id)) {
        return myMenu
      } else {
        return othersMenu
      }
    },
    typeDetail() {
      const userType = this.userInfo.type
      let detail = ''
      switch (userType) {
        case UserType.StationMaster:
          detail = '靓仔'
          break
        case UserType.Admin:
          detail = '管理猿'
          break
        case UserType.Developer:
          detail = '开发者'
          break
        case UserType.Normal:
          detail = '正常人'
          break
        default:
          detail = '游客'
          break
      }
      return detail
    },
    joinTime() {
      const { createTime } = this.userInfo
      const now = new Date().getTime()
      const days = (now - createTime) / (24 * 60 * 60 * 1000)
      return `诞生${parseInt(days)}天`
    },
    // 审核已通过的插件列表
    plugins() {
      let plugins = this.userInfo.works || []
      plugins = plugins.filter((plugin) => {
        return plugin.reviewState === Review.Agree
      })
      return plugins
    }
  },
  mounted() {
    const myInfo = this.$store.getters['globalData/userInfo']
    if (Number(myInfo.id) === Number(this.$route.params.id)) {
      this.userInfo = myInfo
      this.timerId = setTimeout(() => {
        this.pageLoading = false
      }, 500)
    } else {
      this.timerId = setTimeout(() => {
        this.getUserInfo()
      }, 500)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
  },
  methods: {
    menuSelectHandle(e) {
      switch (e.code) {
        case 'updateMe':
          this.goToEdit()
          break
        case 'concatAuthor':
          this.sendEmail()
          break
        case 'updatePassword':
          this.$router.$push({ name: 'UpdatePassword' })
          break
        default:
          break
      }
      this.showMenu = false
    },
    goToEdit() {
      this.$router.$push({
        name: 'UpdateUser'
      })
    },
    sendEmail() {
      // 标题
      const subject = 'via插件：来自用户的邮件'
      // 内容
      const body = '你好，我是via插件网的用户，我是通过你的个人主页联系你的。'
      const from = 'via_plugin@163.com'
      const to = this.userInfo.email
      window.location = `
        mailto:${to}?cc=${from}&subject=${subject}&body=${body}
      `
    },
    getUserInfo() {
      this.pageLoading = true
      this.$api.user.findById(this.$route.params.id).then(res => {
        this.userInfo = res.data
        this.pageLoading = false
      }).catch(() => { this.pageLoading = false })
    }
  }
}
</script>

<style scoped>
.nav-right {
  color: var(--themeColor);
}
.top-bg {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 375px;
  height: 300px;
  background-color: var(--light90);
}
.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  box-shadow: var(--boxShadow-bottom);
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.nickname {
  color: var(--light40);
  margin-top: 15px;
  font-weight: 900;
}
.tags {
  margin-top: 15px;
  width: 100%;
  display: flex;
  justify-content: center;
}
.tag {
  font-size: 12px;
  color: var(--light100);
  height: 20px;
  line-height: 20px;
  border-radius: 10px;
  margin-right: 12px;
  padding: 0 8px;
}
.tag.user-type {
  background-color: var(--successColor);
}
.tag.join-time {
  background-color: rgba(0, 0, 0, 0.5);
}
.introduction {
  color: var(--light40);
  margin-top: 15px;
  font-size: 13px;
  max-width: 300px;
  line-height: 26px;
}
.plugin-list {
  width: 375px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.plugin-list-card {
  margin-top: 15px;
  border-radius: 15px;
}
</style>
